var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9996 11.9999C23.9996 18.6168 18.6165 24 11.9998 24C5.38314 24 0 18.6168 0 11.9999C0 5.38325 5.38314 0 11.9998 0C18.6165 0 23.9996 5.38325 23.9996 11.9999ZM22.357 11.9999C22.3569 6.28892 17.7107 1.6427 11.9998 1.6427C6.28892 1.6427 1.64281 6.28903 1.64281 11.9998C1.64281 17.711 6.28892 22.3572 11.9998 22.3573C17.7109 22.3572 22.357 17.711 22.357 11.9999ZM11.5498 17.1396C11.2291 17.4602 10.7091 17.4603 10.3883 17.1396L5.82958 12.5812C5.67549 12.4269 5.58898 12.2182 5.58887 12.0002C5.58887 11.7823 5.67538 11.5735 5.82947 11.4195L10.3884 6.86067C10.5488 6.70045 10.759 6.62018 10.9692 6.62018C11.1794 6.62018 11.3896 6.70045 11.55 6.86078C11.8708 7.18144 11.8708 7.70162 11.55 8.02239L8.39307 11.1791L17.5331 11.1782C17.9867 11.1782 18.3543 11.5458 18.3544 11.9994C18.3544 12.4532 17.9868 12.8208 17.5332 12.8209L8.39351 12.8218L11.5497 15.9779C11.8707 16.2988 11.8707 16.8187 11.5498 17.1396Z",
    fill: "#FF3131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.ee9b6e345f499b090293f8541afbba26.svg";
export { ForwardRef as ReactComponent };